import React, { useState } from 'react'
import { Col, Row, Checkbox } from 'antd'
import { EditOutlined, DeleteTwoTone, DownloadOutlined } from '@ant-design/icons'

import { Link } from 'react-router-dom'
import style from './style.module.scss'

// This compnent is used in the files list
const Card = ({
  isFavourite,
  isNew,
  image,
  name,
  creationDate,
  tags,
  id,
  etag,
  onToggleCheck,
  onDelete,
  onDownload,
}) => {
  const [favourite, setFavourite] = useState(isFavourite)

  const setIsFavourite = e => {
    e.preventDefault()
    setFavourite(!favourite)
  }

  return (
    <div className="card overflow-hidden">
      <div hidden={!isNew} className={style.new}>
        New
      </div>
      <div className="card-body">
        <div className={style.selector}>
          <a
            role="menuitem"
            className={`${style.favourite} ${favourite ? 'text-red' : 'text-gray-3'}`}
            onClick={setIsFavourite}
            onKeyPress={setIsFavourite}
            tabIndex="0"
          >
            <i className="fe fe-heart font-size-21" />
          </a>

          <Checkbox className={style.delete_checkbox} onChange={e => onToggleCheck(e, etag)} />
        </div>
        <Link to={`/files/detail/${id}`}>
          <div className={`${style.image} height-250 mb-2`}>
            <img className="img-fluid" src={`data:image/jpeg;base64,${image}`} alt={name} />
          </div>
          <div className="border-top pt-2 font-size-22 font-weight-bold text-dark mb-2">
            <strong>{name}</strong>
          </div>{' '}
        </Link>
        <div className="first_tags mt-2 mb-2">
          Tags:
          {tags.slice(0, 6).map(tag => (
            <span key={`key_${tag}`} className="ms-1 font-size-12 badge badge-default">
              {tag}
            </span>
          ))}
        </div>
        <div>
          <span className="text-blue font-size-12">{creationDate}</span>
        </div>
      </div>
      <div className="card-action">
        <div className={`${style.image} border-bottom`} />
        <Row justify="center" align="middle" className="py-2 text-center">
          <Col span={7} className="border-right">
            <EditOutlined />
          </Col>
          <Col span={7}>
            <DownloadOutlined
              style={{ fontSize: '1.4em', color: '#0082c9' }}
              onClick={() => onDownload(name)}
            />
          </Col>
          <Col span={7} className="border-left">
            <DeleteTwoTone twoToneColor="#eb2f96" onClick={() => onDelete(id, name)} />
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Card
